import { render, staticRenderFns } from "./setExam.vue?vue&type=template&id=da42526c&scoped=true&"
import script from "./setExam.vue?vue&type=script&lang=js&"
export * from "./setExam.vue?vue&type=script&lang=js&"
import style0 from "./setExam.vue?vue&type=style&index=0&id=da42526c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da42526c",
  null
  
)

export default component.exports